import { render, staticRenderFns } from "./fmHBLSingleRelease.vue?vue&type=template&id=63039534&"
import script from "./fmHBLSingleRelease.vue?vue&type=script&lang=js&"
export * from "./fmHBLSingleRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63039534')) {
      api.createRecord('63039534', component.options)
    } else {
      api.reload('63039534', component.options)
    }
    module.hot.accept("./fmHBLSingleRelease.vue?vue&type=template&id=63039534&", function () {
      api.rerender('63039534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/fmHBLSingleRelease.vue"
export default component.exports